import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import { NOTIFICATION_TAB } from 'lib/config';

const NavPage = ({
  paramsNavigation = [
    { name: 'Profile', href: '/profile' },
    { name: 'Business', href: '/business-profile' },
    { name: 'Users', href: '/users' },
    { name: 'Settings', href: '/settings' },
    { name: 'Manage Notifications', href: '/manage-notifications' },
  ],
}) => {
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const userProfile = useSelector((state) => state.profile.data);
  const listAccess = useSelector((state) => state.merchantRoleAccess.data);
  const navigationToRender =
    userProfile?.role !== 'superadmin' ? [paramsNavigation[0]] : paramsNavigation;

const haveAccessNotifcations = (access, flag) => {
    if (!access) return false;
    return flag !== 'disabled'
  };

  const filteredNavigation = useMemo(() => {
    return navigationToRender.filter((item) => {
      if (item.name === 'Manage Notifications') {
        return haveAccessNotifcations(listAccess?.data?.access, NOTIFICATION_TAB);
      }
      return true;
    });
  }, [navigationToRender, haveAccessNotifcations]);
  return (
    <header className="border-b border-gray-200">
      <nav className="flex overflow-x-auto">
        <ul className="flex min-w-full flex-none gap-x-6 text-sm font-semibold leading-6 py-3 px-4 mb-0">
          {filteredNavigation.map((item) => (
            <li key={item.name}>
              <Link
                to={item.href}
                className={`${
                  pathDirect.includes(item.href)
                    ? 'text-primary-main'
                    : 'text-gray-400 hover:text-primary-main'
                } p-1 block no-underline hover:no-underline`}>
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default NavPage;
